import { memo } from "react";

import { useGetIsBlockedByStreamer } from "_common/hooks/global";
import { useGetOwnReactionsCount }   from "_common/hooks/stream";
import { useGetReactions }           from "_common/hooks/stream";
import RxnMap                        from "_common/utils/reactions";

import Presentation from "./presentation";

const component = () => {

	const reactions           = useGetReactions ();
	const ownReactions        = useGetOwnReactionsCount ();
	const isBlockedByStreamer = useGetIsBlockedByStreamer ();

	if ( isBlockedByStreamer )
		return null;

	const allReactions       = {};
	const availableReactions = Object.keys ( RxnMap );

	availableReactions.forEach ( reactionId => {
		let prevCount = 0;
		let showCount = 0;

		prevCount += reactions[reactionId]?.previousCount || 0;
		prevCount += ownReactions[reactionId]?.previousCount || 0;

		showCount += reactions[reactionId]?.showCount || 0;
		showCount += ownReactions[reactionId]?.showCount || 0;

		allReactions[reactionId] = {
			previousCount : prevCount,
			showCount     : showCount
		};
	} );

	return (
		<Presentation
			reactions = { allReactions }
			RxnMap    = { RxnMap }
		/>
	);
};

export default memo ( component );
